import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Card, Col, Form, Input, Modal, notification, Row, Table } from 'antd';

import DF from 'DisplayFramework';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  FindRuleParams,
  findRule,
  ParRuleResponse,
  checkApplicationRuleRequest,
  checkApplicationRule,
} from 'services/workflow';
import ParListSelect from 'components/ParListSelect';
import Text from 'antd/lib/typography/Text';
import FormInput from 'components/FormInput';
import MgUserListSelect from 'components/MgUserListSelect';
import CheckButtonAction from 'components/CheckButtonAction';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import PaymentSelect from 'components/PaymentSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import AssetSelect from 'components/AssetSelect';
import ProposalSelect from 'components/ProposalSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Checkbox from 'components/Checkbox';
import ButtonOperation from 'components/ButtonOperation';
import PoSelect from 'components/POSelect';
import GuarantySelect from 'components/GuarantySelect';
import DocSelect from 'components/DocSelect';
import ScoringSelect from 'components/ScoringSelect';
import CollectionSelect from 'components/CollectionSelect';
import GetLabel from 'DisplayFramework/components/GetLabel';

type RuleListModalProps = {
  module?: string;
  visible: boolean;
  onCancel: () => void;
  setApplicationRule: (value: string) => void;
  valueRule: string;
};
const RuleListModal = (props: RuleListModalProps) => {
  const { visible, onCancel, module, valueRule } = props;

  const [form] = Form.useForm();
  const [ruleSelected, setRuleSelected] = useState<any>();
  const [searchParams, setSearchParams] = useState<FindRuleParams>({
    critcode: '',
    rulcode: '',
    rullabel: '',
    rulmodule: module ?? '',
  });
  // eslint-disable-next-line no-unused-vars
  let [isFirst, setIsFirst] = useState<boolean>(true);
  const [value, setValue] = useState('');

  const fieldName = 'Criterias';
  const { data: rulebytype, refetch } = useQuery(
    ['findRule', { ...searchParams, rulmodule: module??'' }],
    () => findRule({ ...searchParams, rulmodule: module??'' }).then((res) => res.list || []),
    { refetchOnMount: true }
  );

  const { data: ruleByUser, refetch: refetchByUser } = useQuery(
    ['findRule', { ...searchParams, rulmodule: 'USER' }],
    () =>
      findRule({ ...searchParams, rulmodule: 'USER' }).then(
        (res) => res.list || []
      ),
    { refetchOnMount: true }
  );
  const [result, setResult] = useState<any>('');
  const [dataSource, setDataSource] = useState(
    rulebytype?.concat(ruleByUser ?? [])
  );
 
  const FilterByNameInput = (
    <Input
      placeholder="Search rule code"
      value={value}
      onChange={(e) => {
        const currValue = e.target.value;
        setValue(currValue);
        let list = rulebytype?.concat(ruleByUser ?? []) ?? [];
        

        const filteredData = list.filter((entry) =>
          entry.rulcode.includes(currValue)
        );
      
        setDataSource(
          filteredData.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.rulid === value.rulid)
          )
        );
      }}
    />
  );
  useEffect(() => {
    if (valueRule) {
      form.setFieldsValue({ applicationRule: valueRule });
    } else form.setFieldsValue({ applicationRule: '' });
    if (module) {
      form.setFieldsValue({ entitylist: module });
    }
    if( (rulebytype || ruleByUser) && !value) {
      setDataSource(
        rulebytype
          ?.concat(ruleByUser ?? [])
          .filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.rulid === value.rulid)
          )
      );
      form.setFieldsValue({ [fieldName]: dataSource });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form, rulebytype, ruleByUser, refetch, refetchByUser, module]);

  const checkapplication = (data: any) => {
    let value: checkApplicationRuleRequest = {
      applicationRule: '',
      entity: module ?? data.entitylist,
      entityid: 0,
      userid: 0,
    };
    
    value = { ...data, entityid: data.entity.id, entity: module };

    checkApplicationRule({ checkRequest: value }).then((resp) => {
      if (resp.code === '200') {
        notification.success({ message: resp.message });
        props.setApplicationRule(data.applicationRule);
        setResult(resp.data);
      } else {
        notification.error({ message: resp.message });
      }
    });
  };
  const columns: DataGridColDef<ParRuleResponse>[] = [
    {
      title: 'rulcode',
      dataIndex: 'rulcode',
      width: '120px',
    },
    {
      title: 'rullabel',
      dataIndex: 'rullabel',
      width: '250px',
    },
  ];
  const onOk = () => {
    props.setApplicationRule(form.getFieldValue('applicationRule'));
    onCancel();
  };

  /* onchange function*/

  const handleEntityChangeUsers = (item: any) => {
    form.setFieldsValue({
      entity: { id: item },
      userid: item,
    });
  };
  const handleEntityChangeProposal = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.ctrid,
        name: item.prcodelabel,
        reference: item.propreference,
      },
    });

    setResult('');
  };
  const handleEntityChangePo = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.poid,
        name: item.clientname,
        reference: item.popreference,
      },
    });

    setResult('');
  };
  const handleEntityChangeGuaranty = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.Guarid,
        name: item.guarantorname,
        reference: item.guarreference,
      },
    });

    setResult('');
  };
  const handleEntityChangeDOC = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.docid,
        name: item.doclabel,
        reference: item.docreference,
      },
    });

    setResult('');
  };
  const handleEntityChangeSCORING = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.scoid,
        name: item.scolabel,
        reference: item.scoreference,
      },
    });

    setResult('');
  };
  const handleEntityChangeCOLLECTION = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.colid,
        name: item.collabel,
        reference: item.colreference,
      },
    });

    setResult('');
  };
  const handleEntityChangethirdparty = (item: any) => {
    form.setFieldsValue({
      entity: { id: item.tpid, name: item.tpname, reference: item.tpreference },
    });

    setResult('');
  };
  const handleEntityChangeCInvoice = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.ciid,
        name: item.clientname,
        reference: item.cireference,
      },
    });

    setResult('');
  };
  const handleEntityChangeAsset = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.assetid,
        name: item.assetlabel,
        reference: item.assetreference,
      },
    });

    setResult('');
  };
  const handleEntityChangeSupplier = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.siid,
        name: item.Suppliername,
        reference: item.sireference,
      },
    });

    setResult('');
  };
  const handleEntityChangePayment = (item: any) => {
    form.setFieldsValue({
      entity: {
        id: item.payid,
        name: item.tpname,
        reference: item.payreference,
      },
    });

    setResult('');
  };

  /* End onchange function*/

  return (
    (<DF.Provider pagcode="rulemodal">
      <Modal
        open={visible}
        title={<GetLabel label='MultiSelect'/>}
        width="1300px"
        style={{ top: 20, right: 0 }}
        onOk={onOk}
        onCancel={onCancel}
      >
        <Form form={form} onFinish={checkapplication}>
          <Row>
            <Col xs={14} span={5}>
              <Row>
                <Col xs={22}>
                  <Form.Item noStyle>
                    <FormInput name="applicationRule">
                      <Input  />
                    </FormInput>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <FormInput name="entitylist">
                    <ParListSelect
                      parcode="WFENTITY"
                      disabled={!!module}
                      onChange={(e) => {
                        setIsFirst(false);
                        setSearchParams({ ...searchParams, rulmodule: e });
                        form.setFieldsValue({ entity: e });
                        refetch();
                      }}
                    />
                  </FormInput>
                </Col>
                <Col span={2} />
                <Col xs={10}>
                  <Checkbox
                    comcode="onlyUser"
                    onChange={(e) => {
                      e.target.checked
                        ? setDataSource(ruleByUser)
                        : setDataSource(rulebytype);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={18}>
                  <Row>
                    {FilterByNameInput}
                    <Table
                      size="small"
                      scroll={{ x: 200, y: 300 }}
                      pagination={false}
                      bordered
                      rowSelection={{
                        columnWidth: 25,
                        type: 'radio',
                        hideSelectAll: false,
                        onSelect: (record: ParRuleResponse) => {
                          setRuleSelected(record.rulcode);
                        },
                      }}
                      dataSource={dataSource}
                      columns={columns}
                      rowKey={(record) => record.rulid}
                    />
                  </Row>
                </Col>
                <Col xs={2}></Col>
                <Col xs={4}>
                  <Row>
                    <ButtonOperation
                      comcode="Add"
                      onClick={() => {
                        const operator = ['&', '|', '(', ')'];
                        const array = form.getFieldValue('applicationRule').split(' ');
                    
                        if(!form.getFieldValue('applicationRule') || array.length === 0 ){
                            form.setFieldsValue({
                                applicationRule: ruleSelected
                            });
                        } else if (operator.includes(array[array.length - 1]) ||
                                   !form.getFieldValue('applicationRule')){
                            form.setFieldsValue({
                                applicationRule: form.getFieldValue('applicationRule') + ' ' + ruleSelected
                            });
                        } else {
                            notification.error({
                                message: 'you must add (And) or ( Or) before rule',
                                duration: 0,
                            });
                        }
                    }}
                      type="primary"
                    />
                  </Row>
                  <br />
                  <Row>
                    <ButtonOperation
                      comcode="("
                      onClick={() => {
                        form.setFieldsValue({
                          applicationRule:
                            form.getFieldValue('applicationRule') + ' (',
                        });
                      }}
                    />
                  </Row>
                  <br />
                  <Row>
                    <ButtonOperation
                      comcode="And"
                      onClick={() => {
                        form.setFieldsValue({
                          applicationRule:
                            form.getFieldValue('applicationRule') + ' &',
                        });
                      }}
                      type="primary"
                    />
                  </Row>
                  <br />
                  <Row>
                    <ButtonOperation
                      comcode="Or"
                      onClick={() => {
                        form.setFieldsValue({
                          applicationRule:
                            form.getFieldValue('applicationRule') + ' |',
                        });
                      }}
                    />
                  </Row>
                  <br />
                  <Row>
                    <ButtonOperation
                      comcode=")"
                      onClick={() => {
                        form.setFieldsValue({
                          applicationRule:
                            form.getFieldValue('applicationRule') + ' )',
                        });
                      }}
                      type="primary"
                    />
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={10}>
              <Card title="Check">
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item noStyle shouldUpdate>
                      {({ getFieldValue }) => {
                        return (
                          <>
                            <Row>
                              <FormInput name="entity">
                                {module === 'THIRDPARTY' ||
                                getFieldValue('entitylist') === 'THIRDPARTY' ? (
                                  <ThirdPartyInput
                                    onChange={(e) => {
                                      handleEntityChangethirdparty(e);
                                    }}
                                  />
                                ) : module === 'USER' ||
                                  getFieldValue('entitylist') === 'USER' ? (
                                  <MgUserListSelect
                                    onChange={(e) => {
                                      handleEntityChangeUsers(e);
                                    }}
                                  />
                                ) : module === 'PROPOSAL' ||
                                  getFieldValue('entitylist') === 'PROPOSAL' ? (
                                  <ProposalSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeProposal(e);
                                    }}
                                    phase=''
                                    isCreate
                                    display={false}
                                   
                                  />
                                ) : module === 'ASSET' ||
                                  getFieldValue('entitylist') === 'ASSET' ? (
                                  <AssetSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeAsset(e);
                                    }}
                                  />
                                ) : module === 'SINVOICE' ||
                                  getFieldValue('entitylist') === 'SINVOICE' ? (
                                  <SupplierInvoiceSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeSupplier(e);
                                    }}
                                  />
                                ) : module === 'PAYMENT' ||
                                  getFieldValue('entitylist') === 'PAYMENT' ? (
                                  <PaymentSelect
                                    onChange={(e: any) => {
                                      handleEntityChangePayment(e);
                                    }}
                                  />
                                ) : module === 'CONTRACT' ||
                                  getFieldValue('entitylist') === 'CONTRACT' ? (
                                  <ProposalSelect
                                  PropOrProd="PROD" phase="" 
                                    onChange={(e: any) => {
                                      handleEntityChangeProposal(e);
                                    }}
                                  />
                                ) : module === 'PURORDER' ||
                                  getFieldValue('entitylist') === 'PURORDER' ? (
                                  <PoSelect
                                    onChange={(e: any) => {
                                      handleEntityChangePo(e);
                                    }}
                                  />
                                ) : module === 'GUARANTY' ||
                                  getFieldValue('entitylist') === 'GUARANTY' ? (
                                  <GuarantySelect
                                    onChange={(e: any) => {
                                      handleEntityChangeGuaranty(e);
                                    }}
                                  />
                                ) : module === 'DOCUMENT' ||
                                  getFieldValue('entitylist') === 'DOCUMENT' ? (
                                  <DocSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeDOC(e);
                                    }}
                                  />
                                ) : module === 'SCORING' ||
                                  getFieldValue('entitylist') === 'SCORING' ? (
                                  <ScoringSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeSCORING(e);
                                    }}
                                  />
                                ) : module === 'COLLECTION' ||
                                  getFieldValue('entitylist') ===
                                    'COLLECTION' ? (
                                  <CollectionSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeCOLLECTION(e);
                                    }}
                                  />
                                ) : (
                                  <ClientInvoiceSelect
                                    onChange={(e: any) => {
                                      handleEntityChangeCInvoice(e);
                                    }}
                                  />
                                )}
                              </FormInput>
                            </Row>
                            <Row>
                            <Col span={10}>
                              {module !== 'USER' && (
                                <FormInput name="userid" rules={[{ required: true ,message:' select a user please '}]}>
                                  <MgUserListSelect
                                  style={{width:'100%'}}
                                    onChange={() => setResult('')}
                                  />
                                </FormInput>
                              )}
                              </Col>
                            </Row>
                            <Row>
                              <Col span={7}>
                                <CheckButtonAction htmlType="submit" />
                              </Col>
                              <Col>
                                <Text>{result}</Text>
                              </Col>
                            </Row>
                          </>
                        );
                      }}
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Form>
      </Modal>
    </DF.Provider>)
  );
};

export default RuleListModal;
